
export class RiferimentoEsternoDTO {
    id: string
    sistema: string
}